<ui-dialog
    [open]="isDeactivateModalOpen"
    (closing)="closeDeactivateModalOpen()"
    header="applicant-tracker.discardEmailAutomation"
>
    <p>{{ 'applicant-tracker.areYouSureYouWantToDiscardThisMessage' | translate }}</p>
    <ui-dialog-footer>
        <ui-button type="ghost" (click)="closeDeactivateModalOpen()">{{ 'cancel' | translate }}</ui-button>
        <ui-button type="danger" (click)="allowNavigation()">{{ 'applicant-tracker.discard' | translate }}</ui-button>
    </ui-dialog-footer>
</ui-dialog>

<ui-dialog
    [open]="isSaveBulkEmailModalOpen"
    (closing)="closeSaveBulkEmail()"
    header="applicant-tracker.saveEmailAutomation"
>
    <p>
        {{
            'applicant-tracker.theEmailSubjectWillBeAutomaticallySent'
                | translate: { subject: jobFunnelMessageTemplate.subject ?? '', stageName: jobFunnel.funnelStep }
        }}
    </p>
    <ui-dialog-footer>
        <ui-button type="ghost" (click)="closeSaveBulkEmail()">{{ 'cancel' | translate }}</ui-button>
        <ui-button type="primary" (click)="onSave(jobFunnelMessageTemplateForm)">{{ 'save' | translate }}</ui-button>
    </ui-dialog-footer>
</ui-dialog>

<ui-dialog
    [open]="isSaveAndSendBulkEmailModalOpen"
    (closing)="closeSaveAndSendBulkEmail()"
    header="applicant-tracker.saveAndSendNow"
>
    <p>
        {{
            'applicant-tracker.theEmailSubjectWillNowBeSentToApplicantsInFunnelStepAndAutomaticallyMoved'
                | translate: { subject: jobFunnelMessageTemplate.subject ?? '', funnelStep: jobFunnel.funnelStep }
        }}
    </p>
    <ui-dialog-footer>
        <ui-button type="ghost" (click)="closeSaveAndSendBulkEmail()">{{ 'cancel' | translate }}</ui-button>
        <ui-button type="primary" (click)="onSaveAndSend(jobFunnelMessageTemplateForm)">{{
            'save' | translate
        }}</ui-button>
    </ui-dialog-footer>
</ui-dialog>

<div class="ui basic segment" [class.loading]="isLoading">
    <app-header
        title="applicant-tracker.setupEmailAutomation"
        [back]="true"
        [subtitle]="'applicant-tracker.thisEmailWillBeSentTOAllActiveParticipants'"
    ></app-header>

    <div class="ui layout">
        <div class="content">
            <div class="ui segment">
                <app-job-funnel-message-template-form
                    [jobFunnel]="jobFunnel"
                    [jobFunnelMessageTemplate]="jobFunnelMessageTemplate"
                    #jobFunnelMessageTemplateForm
                    (isLoading)="isLoading = $event"
                ></app-job-funnel-message-template-form>
                <div class="flex justify-end">
                    <ui-button (click)="onSendTest(jobFunnelMessageTemplateForm)" type="link">{{
                        'applicant-tracker.sendATest' | translate
                    }}</ui-button>
                    <ui-button
                        [matMenu]="saveDropdown"
                        type="primary"
                        (menuClosed)="expandSaveDropdown = false"
                        (menuOpened)="expandSaveDropdown = true"
                        >{{ 'save' | translate }}
                        <mat-icon *ngIf="!expandSaveDropdown" svgIcon="chevronDown"></mat-icon>
                        <mat-icon *ngIf="expandSaveDropdown" svgIcon="chevronUp"></mat-icon
                    ></ui-button>
                    <mat-menu #saveDropdown xPosition="before">
                        <button name="save" mat-menu-item (click)="openSaveBulkEmail()">
                            {{ 'save' | translate }}
                        </button>
                        <button name="saveAndSend" mat-menu-item (click)="openSaveAndSendBulkEmail()">
                            {{ 'applicant-tracker.saveAndSend' | translate }}
                        </button>
                    </mat-menu>
                </div>
            </div>
        </div>
        <div class="sidebar">
            <app-customization-tokens></app-customization-tokens>
        </div>
    </div>
</div>
